<script>
  import Start from "./Start.svelte";
  import Question from "./Question.svelte";
  import Lose from "./Lose.svelte";
  import Win from "./Win.svelte";

  import { step, stats } from "./stores.js";

  import { getMoodEmoji } from "./helpers";

  const { mood, money, rating } = stats;

  $: moodImageUrl = `./img/emoji/${getMoodEmoji($mood)}.png`;

  let isLose = false;

  stats.money.subscribe((balance) => {
    isLose = balance < 1;
  });
</script>

<div class="content">
  <div class="container">
    <div class="main-wrap">
      <div class="logo"><img src="./img/logo.png" alt="logo" /></div>
      <nav class="nav dekstop">
        <ul>
          <li class="nav__elem">
            <img class="left-icon" src="./img/icon_money.png" alt="icon_money" />
            <span class="nav__text">Состояние компании</span>
            <span class="margin-span">{$money}</span>
          </li>
          <li class="nav__elem nav__elem--mood">
            <span class="nav__text">Настроение сотрудников</span>
            <img class="emoji" src={moodImageUrl} alt="mood_image" />
          </li>
          <li class="nav__elem">
            <img class="left-icon" src="./img/icon_rating.png" alt="icon_rating" />
            <span class="nav__text">Рейтинг</span>
            <span class="margin-span">{$rating}</span>
          </li>
        </ul>
      </nav>
      {#if $step === null}
        <Start />
      {:else if isLose}
        <Lose />
      {:else if $step === 'finish'}
        <Win />
      {:else}
        <Question />
      {/if}
    </div>
  </div>
</div>
